module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter10"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "href": "#/003toc#ch10"
    }
  }, [_vm._v("Ginger Pear Pumpkin Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pumpkin isn’t just for Halloween and shouldn’t be reserved for pies. This delicious soup spiked with ground ginger will be a welcome warm-up on a cool evening when served with some crusty bread. The soup can be frozen for up to two months.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4 tablespoons (½ stick) unsalted butter")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("½ cup finely chopped sweet onion")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("½ cup finely chopped celery")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("½ cup finely chopped carrot")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 medium red pears, peeled, cored, and finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("½ teaspoon ground ginger")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Two 15-ounce cans pumpkin purée (see savvy)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3 cups chicken broth")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 cup heavy cream")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("melt the butter in a medium skillet over medium-high heat. Add the onion, celery, carrot, pears, and ginger and sauté until the vegetables begin to soften, about 3 minutes. Transfer the contents of the skillet to the insert of a 5- to 7-quart slow cooker.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("stir in the pumpkin and broth. Cover and cook on high for 3 hours or on low for 5 to 6 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("season with salt and pepper. Stir in the cream, cover, and leave on warm for 30 minutes before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("serves 8")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "sidebar_head"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image 1",
      "src": "images/image-01.jpg"
    }
  }), _vm._v("pumpkin savvy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pumpkin purée sold in cans is terrific for any preparation that calls for pumpkin. Cooking your own pumpkin can be a messy and frustrating process that sometimes ends with a watery mess. Make sure to buy pumpkin purée and not pumpkin pie filling.")])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b105832","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/016-chapter10.vue
// module id = 102
// module chunks = 0